import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { Box, Button, Paper, TextField, Checkbox } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import { useCookies } from "react-cookie";
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AppHeader from "../component/AppHeader";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import api from "../../API";
import DocumentUploadPage from "./document/DocumentUploadPage";
import ScriptListPage from "./col/ScriptListPage";
import NKIWorkerListPage from "./col/NKIWorkerListPage";
import ConfirmListPage from "../sample/ConfirmListPage_bak";
import ScriptUploadPage from "./script/ScriptUploadPage";
// import SampleListPage from "./SampleListPage";
// import SampleUploadPage from "./SampleUploadPage";
// import DocumentUploadPage from "./DocumentUploadPage";
// import ConfirmListPage from "./ConfirmListPage";

interface IFileTypes {
  id: number;
  object: File;
}

const WorkPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // const [speaker1, setSpeaker1] = useState('');
  // const [speaker2, setSpeaker2] = useState('');

  // console.log('workuploadpage', auth , auth.user.roles.filter((obj:any) => obj.role === 'NKI'))

  // const sample_confirm = auth.user.roles.some((obj:any) => obj.use_yn === 'sample_confirm')


  const user_state = useSelector((state:any)=> state.userInfo.data.user.state)

  console.log('사용자 user_state',user_state)

  // console.log('샘플 페이지 ??? ', auth.user.roles)

  const [samples, setSamples] = useState<IFileTypes[]>([]);
  
  const [sampleListPage, setSampleListPage] = useState<boolean>(false)

  const getAuth = async () => {

    console.log('WorkPage /@me 이메일', email)
    if(!email){
      nav('/')
    }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const steps = [
    '샘플제출단계',
    '계약정보 입력단계',
    '본작업 수집데이터 제출단계',
  ];

  useEffect(() => {
    getAuth()
  },[])

  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 38,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(33, 242, 43) 0%,rgb(44, 165, 60) 50%,rgb(59, 83, 190) 100%)',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(44, 165, 60) 0%,rgb(33, 242, 43) 50%,rgb(112, 219, 156) 100%)',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 5,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));

  const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    display: 'flex',
    width: 80,
    height: 80,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex:1,
    ...(ownerState.active && {
      backgroundImage:
        'linear-gradient( 136deg, rgb(64, 95, 233) 20%, #ffffff 50%, rgb(64, 95, 233) 80%)'
    }),
    ...(ownerState.completed && {
      backgroundImage:
        'linear-gradient( 136deg, #ffffff 0%, rgb(33, 242, 43) 80%, rgb(33, 242, 43) 100%)'
    }),
  }));

  function ColorlibStepIcon(props: any) {
    const { active, completed, className } = props;
  
    const icons: { [index: string]: React.ReactElement } = {
      1: <img style={{width:"60px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/report.png'} />,
      2: <img style={{width:"50px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/project.png'} />,
      3:<img style={{width:"52px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/upload.png'} />,
    };
  
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }

  return (
    <Box>
      <Box sx={{ display:"flex", justifyContent:"center", width:"100%",fontSize: "100px", fontWeight: 600, backgroundColor: "#fff", height: "500%", maxWidth: "100%", marginTop:"50px"}}>
      {(user_state !== "script") ? 
        <Stepper activeStep={(user_state == 'sample_upload' ? 0 : (['sample_confirm','document_upload'].includes(user_state) ? 1 : 2))} alternativeLabel connector={<ColorlibConnector />}>
          {steps.map((label) => (
            <Step key={label} >
              <StepLabel StepIconComponent={ColorlibStepIcon} sx={{marginLeft:"40px",marginRight:"40px",fontWeight:600}}>
                <Box sx={{fontSize:"20px",fontWeight:600}}>{label}</Box>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      :""}
      </Box>
      <Box>
        <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
          {/* <AppHeader /> */}
          
          {(user_state === "script") ? 
            <Box sx={{display:"flex" , justifyContent: "center", marginTop:"100px"}}>
              {/* <ConfirmListPage /> */}
              <ScriptUploadPage getAuth={getAuth}/>
              {/* <Button sx={{width: "230px", fontSize: "24px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>업로드 페이지</>: <>제출현황 페이지</>}</Button> */}
            </Box>  
          :""}

          {(user_state === "sample_confirm") || (user_state === "document_upload") ? 
            <Box sx={{display:"flex" , justifyContent: "center", marginTop:"100px"}}>
              {/* <ConfirmListPage /> */}
              <DocumentUploadPage getAuth={getAuth}/>
              {/* <Button sx={{width: "230px", fontSize: "24px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>업로드 페이지</>: <>제출현황 페이지</>}</Button> */}
            </Box>  
          :""}

          {user_state === "work_start" ? 
            <Box sx={{marginTop:"50px", width:"80%",margin:"auto"}}>
              {/* <Box sx={{display:"flex"}}> */}
                <Box><ScriptListPage/></Box>
                {/* <Box><NKIWorkerListPage setSpeaker2={setSpeaker2}/></Box> */}
              {/* </Box> */}
              {/* <Button sx={{width: "230px", fontSize: "24px", fontWeight: 600, backgroundColor: sampleListPage? "#404ec7" : "#3fb92e", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=>setSampleListPage(!sampleListPage)}>{sampleListPage? <>업로드 페이지</>: <>제출현황 페이지</>}</Button> */}
            </Box>  
          :""}
          
          {/* <Box sx={{display: 'flex', justifyContent: "center", padding:"72px"}}>
              {sampleListPage ?
                <SampleListPage samples={samples} />
              :
                (sample_confirm ?
                  // 문서 제출
                  <ConfirmListPage samples={samples} sampleUploadList={sampleUploadList}  />
                  :
                  // 샘플 파일 업로드
                  <SampleUploadPage sampleUploadList={sampleUploadList} />
                )
              }
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
};

export default WorkPage;
